import './registerServiceWorker';

import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';

import App from './App.vue';
import TouchEvents from './lib/touch-events';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import router from './router';
import store from './store';

if (typeof crypto.randomUUID !== 'function') {
    crypto.randomUUID = (() => {
        const hex = [...crypto.getRandomValues(new Uint8Array(16))].map((b) =>
            b.toString(16).padStart(2, '0')
        );

        return [
            hex.slice(0, 4).join(''),
            hex.slice(4, 6).join(''),
            '4' + hex[6].slice(1), // version 4 UUID
            ((+hex[8] & 0x3f) | 0x80).toString(16) + hex[9].slice(1),
            hex.slice(10, 16).join(''),
        ].join('-');
    }) as () => `${string}-${string}-${string}-${string}-${string}`;
}

window.addEventListener('resize', setVhUnit);
setVhUnit();

function setVhUnit() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

loadFonts();

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
app.use(router).use(store).use(vuetify).use(pinia).use(TouchEvents).mount('#app');

app.config.warnHandler = (msg, instance, trace) => {
    if (
        msg.includes('Failed to resolve component: v-tab-item') ||
        msg.includes('Failed to resolve component: v-tabs-items')
    ) {
        return;
    }
    console.warn(msg + trace);
};

window.addEventListener('error', (event) => {
    if (
        event.message?.includes('ChunkLoadError') ||
        event.message?.includes('Unexpected token <') ||
        (event.filename && event.filename.includes('/js/'))
    ) {
        handleChunkReload('error');
    }
});

window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    if (
        reason?.name === 'ChunkLoadError' ||
        reason?.message?.includes('ChunkLoadError') ||
        reason?.message?.includes('Unexpected token <')
    ) {
        handleChunkReload('unhandledrejection');
    }
});

function handleChunkReload(source: string) {
    const reloadKey = 'lastChunkReload';
    const now = Date.now();
    const lastReload = Number(localStorage.getItem(reloadKey)) || 0;

    if (now - lastReload > 30000) {
        localStorage.setItem(reloadKey, String(now));
        console.warn(`[${source}] Chunk load failure detected. Reloading app...`);
        window.location.reload();
    } else {
        console.error(`[${source}] Reload suppressed to avoid loop`);
    }
}
